import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	addButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	partialIssueFailureFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleIssueMissingResolvePermFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleIssueMissingEditPermFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleIssueMissingPermsFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twoIssuesMissingResolvePermFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twoIssuesMissingEditPermFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twoIssuesMissingPermsFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleIssuesMissingResolvePermFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleIssuesMissingEditPermFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleIssuesMissingPermsFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addButtonIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorFlagTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	partialIssueFailureFlagTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleIssuesMissingResolvePermFlagDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleIssuesMissingEditPermFlagDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleIssuesMissingPermsFlagDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	addButton: {
		id: 'software-releases-add-issues-to-version.add-button',
		defaultMessage: 'Add issues',
		description: 'Add issues to version button text',
	},
	errorFlagTitle: {
		id: 'software-releases-add-issues-to-version.error-flag-title',
		defaultMessage: "Can't add {totalCount, plural, one {issue} other {# issues}} to version",
		description: 'Flag description for failure to update version description',
	},
	errorFlagDescription: {
		id: 'software-releases-add-issues-to-version.error-flag-description',
		defaultMessage:
			'Something went wrong. Please try again or contact your administrator if the problem persists.',
		description: 'Flag description for failure to update version description',
	},
	successFlagDescription: {
		id: 'software-releases-add-issues-to-version.success-flag-description',
		defaultMessage:
			'{issueCount, plural, one {# issue has been added} other {# issues have been added}}.',
		description: 'Flag message when issues are successfully added to the version',
	},
	partialIssueFailureFlagTitle: {
		id: 'software-releases-add-issues-to-version.partial-issue-failure-flag-title',
		defaultMessage: '{failedIssueCount} out of {totalCount} issues not added to version.',
		description: 'Flag title when there is partial failures while adding issues to a version.',
	},
	singleIssueMissingResolvePermFlagDescription: {
		id: 'software-releases-add-issues-to-version.single-issue-missing-resolve-perm-flag-description',
		defaultMessage: "You don't have permission to resolve {issueKey}, so it wasn't added.",
		description:
			'Flag message when the user does not have permission to resolve one of the selected issues.',
	},
	singleIssueMissingEditPermFlagDescription: {
		id: 'software-releases-add-issues-to-version.single-issue-missing-edit-perm-flag-description',
		defaultMessage: "You don't have permission to edit {issueKey}, so it wasn't added.",
		description:
			'Flag message when the user does not have permission to edit one of the selected issues.',
	},
	singleIssueMissingPermsFlagDescription: {
		id: 'software-releases-add-issues-to-version.single-issue-missing-perms-flag-description',
		defaultMessage: "You don't have permission to edit or resolve {issueKey}, so it wasn't added.",
		description:
			'Flag message when the user does not have permission to resolve and edit one of the selected issues.',
	},
	twoIssuesMissingResolvePermFlagDescription: {
		id: 'software-releases-add-issues-to-version.two-issues-missing-resolve-perm-flag-description',
		defaultMessage:
			"You don't have permission to resolve {issueKey1} and {issueKey2}, so they weren't added.",
		description:
			'Flag message when the user does not have permission to resolve two of the selected issues.',
	},
	twoIssuesMissingEditPermFlagDescription: {
		id: 'software-releases-add-issues-to-version.two-issues-missing-edit-perm-flag-description',
		defaultMessage:
			"You don't have permission to edit {issueKey1} and {issueKey2}, so they weren't added.",
		description:
			'Flag message when the user does not have permission to edit two of the selected issues.',
	},
	twoIssuesMissingPermsFlagDescription: {
		id: 'software-releases-add-issues-to-version.two-issues-missing-perms-flag-description',
		defaultMessage:
			"You don't have permission to edit or resolve {issueKey1} and {issueKey2}, so they weren't added.",
		description:
			'Flag message when the user does not have permission to resolve and edit two of the selected issues.',
	},
	multipleIssuesMissingResolvePermFlagDescription: {
		id: 'software-releases-add-issues-to-version.multiple-issues-missing-resolve-perm-flag-description',
		defaultMessage:
			"You don't have permission to resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added.",
		description:
			'Flag message when only part of the selected issues are successfully added to the version',
	},
	multipleIssuesMissingEditPermFlagDescription: {
		id: 'software-releases-add-issues-to-version.multiple-issues-missing-edit-perm-flag-description',
		defaultMessage:
			"You don't have permission to edit {failedCount, plural, one {issue} other {# issues}}, so they weren't added.",
		description:
			'Flag message when only part of the selected issues are successfully added to the version',
	},
	multipleIssuesMissingPermsFlagDescription: {
		id: 'software-releases-add-issues-to-version.multiple-issues-missing-perms-flag-description',
		defaultMessage:
			"You don't have permission to edit or resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added.",
		description:
			'Flag message when only part of the selected issues are successfully added to the version',
	},
	addButtonIssueTerminologyRefreshM4: {
		id: 'software-releases-add-issues-to-version.add-button-issue-terminology-refresh-m4',
		defaultMessage: 'Add work items',
		description: 'Add issues to version button text',
	},
	errorFlagTitleIssueTerminologyRefreshM4: {
		id: 'software-releases-add-issues-to-version.error-flag-title-issue-terminology-refresh-m4',
		defaultMessage:
			"Can't add {totalCount, plural, one {work item} other {# work items}} to version",
		description: 'Flag description for failure to update version description',
	},
	successFlagDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-add-issues-to-version.success-flag-description-issue-terminology-refresh-m4',
		defaultMessage:
			'{issueCount, plural, one {# work item has been added} other {# work items have been added}}.',
		description: 'Flag message when issues are successfully added to the version',
	},
	partialIssueFailureFlagTitleIssueTerminologyRefreshM4: {
		id: 'software-releases-add-issues-to-version.partial-issue-failure-flag-title-issue-terminology-refresh-m4',
		defaultMessage: '{failedIssueCount} out of {totalCount} work items not added to version.',
		description: 'Flag title when there is partial failures while adding issues to a version.',
	},
	multipleIssuesMissingResolvePermFlagDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-add-issues-to-version.multiple-issues-missing-resolve-perm-flag-description-issue-terminology-refresh-m4',
		defaultMessage:
			"You don't have permission to resolve {failedCount, plural, one {work item} other {# work items}}, so they weren't added.",
		description:
			'Flag message when only part of the selected issues are successfully added to the version',
	},
	multipleIssuesMissingEditPermFlagDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-add-issues-to-version.multiple-issues-missing-edit-perm-flag-description-issue-terminology-refresh-m4',
		defaultMessage:
			"You don't have permission to edit {failedCount, plural, one {work item} other {# work items}}, so they weren't added.",
		description:
			'Flag message when only part of the selected issues are successfully added to the version',
	},
	multipleIssuesMissingPermsFlagDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-add-issues-to-version.multiple-issues-missing-perms-flag-description-issue-terminology-refresh-m4',
		defaultMessage:
			"You don't have permission to edit or resolve {failedCount, plural, one {work item} other {# work items}}, so they weren't added.",
		description:
			'Flag message when only part of the selected issues are successfully added to the version',
	},
});
export default messages;
